import api from 'Application/api/api';

const archieveAllNotifications = async (signal, email) =>
	await api.put(`/notifications/set-archived-all?email=${email}`, {
		signal,
	});

export default archieveAllNotifications;
